import { useCallback, useState } from 'react';

import { downloadStockTransferExcel } from '#/api/imsMgmt/receipts/stockTransfer/downloadExcel';
import { getStockTransferApiErrorMessage } from '#/modules/imsMgmt/receipts/stockTransfer/helper/apiError';
import { getFileTransferErrorMessage } from '#/utils/blobResponseError';
import { triggerBlobDownload } from '#/utils/downloadBlob';
import { toast } from '#/utils/toast';

function useStockTransferExcelDownload(id) {
  const [isPrintPending, setIsPrintPending] = useState(false);

  const handlePrint = useCallback(async () => {
    if (!id || isPrintPending) {
      return;
    }

    setIsPrintPending(true);
    try {
      const { blob, filename } = await downloadStockTransferExcel(id);
      triggerBlobDownload(blob, filename);
    } catch (error) {
      toast.error(
        getFileTransferErrorMessage(error)
        || getStockTransferApiErrorMessage(error, '下載 Excel 失敗'),
      );
    } finally {
      setIsPrintPending(false);
    }
  }, [id, isPrintPending]);

  return {
    canPrint: Boolean(id),
    isPrintPending,
    handlePrint,
  };
}

export default useStockTransferExcelDownload;
